module.exports = __webpack_public_path__ + "static/img/icon-phone-scan.3e9bcc6.svg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/newCode/qrCode/icon-phone-scan.svg
// module id = 1081
// module chunks = 2